import React from 'react';

const SmartGuideModal = ({
  open,
  tab = 'price',
  onTabChange,
  dontShow,
  onChangeDontShow,
  onClose,
  showDontShowOption = true,
  onPrevTip,
  onNextTip,
  hasPrevTip = false,
  hasNextTip = false,
}) => {
  if (!open) return null;

  const currentTab = tab || 'price';
  const isPriceGuide = currentTab === 'price';
  const isProductGuide = currentTab === 'product';
  const isEmailGuide = currentTab === 'email';
  const isScheduleGuide = currentTab === 'schedule';
  const isConsultGuide = currentTab === 'consult';
  const isConsultFlowGuide = currentTab === 'consult-flow';

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
      />
      <div className="relative z-10 w-[min(960px,98vw)] max-h-[90vh] overflow-auto bg-white rounded-2xl shadow-2xl border border-gray-200 p-6">
        <div className="flex items-start justify-between mb-4">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              {isPriceGuide
                ? '스마트 가격 등록 안내'
                : isProductGuide
                  ? '스마트 상품 등록 안내'
                  : isEmailGuide
                    ? '상세 설정 이메일 발송 안내'
                    : isScheduleGuide
                      ? '상세 설정 일정 스마트 등록 안내'
                      : isConsultGuide
                        ? '상담(견적) 관리 스마트 활용 안내'
                        : '상담-상품-예약 원플로우 안내'}
            </h2>
            <p className="mt-1 text-sm text-gray-500">
              {isPriceGuide
                ? '여러 날짜의 요금과 재고를 텍스트/표 붙여넣기로 한 번에 등록하는 방법을 영상으로 확인해 보세요.'
                : isProductGuide
                  ? '엑셀, 한글, 워드 문서를 그대로 붙여 넣으기만 하면 자동으로 상품이 생성되는 스마트 상품 등록 기능을 소개합니다.'
                  : isEmailGuide
                    ? '상세 설정 화면 우측 일정표 미리보기 영역에서 여행상품 웹 일정표를 이메일로 발송하는 방법을 안내합니다.'
                    : isScheduleGuide
                      ? '투어 상품 상세 설정 화면에서 이미 등록된 상품도 "일정 스마트 등록" 버튼을 통해 엑셀, 워드, 한글 일정표를 그대로 붙여넣어 상세 페이지 및 일정표를 자동으로 생성하는 방법을 안내합니다.'
                      : isConsultGuide
                        ? '상담(견적) 등록부터 자동 생성된 상품, 일정 스마트 등록, 이메일 발송까지 한 흐름으로 관리하여 별도의 견적서를 작성하지 않고도 거래처/고객에게 웹 일정표를 전달하는 방법을 안내합니다.'
                        : '상담에서 생성된 견적과 자동 생성 상품, 예약 작성까지 한 흐름으로 이어져 별도의 상품·견적 매칭 없이 통합 관리할 수 있는 방법을 안내합니다.'}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="ml-4 inline-flex items-center justify-center rounded-full p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300"
            aria-label="닫기"
          >
            <span className="text-base leading-none">×</span>
          </button>
        </div>

        <div className="mb-5">
          <div className="relative w-full overflow-hidden rounded-xl bg-black">
            <iframe
              className="w-full h-[360px] max-h-[50vh]"
              src={isPriceGuide
                ? 'https://www.youtube.com/embed/vLNXIZxd5Co?autoplay=1&mute=1&loop=1&playlist=vLNXIZxd5Co'
                : isProductGuide
                  ? 'https://www.youtube.com/embed/6mzkcKZrL74?autoplay=1&mute=1&loop=1&playlist=6mzkcKZrL74'
                  : isEmailGuide
                    ? 'https://www.youtube.com/embed/CfAKwFmOwxM?autoplay=1&mute=1&loop=1&playlist=CfAKwFmOwxM'
                    : isScheduleGuide
                      ? 'https://www.youtube.com/embed/_INeylPnczg?autoplay=1&mute=1&loop=1&playlist=_INeylPnczg'
                      : isConsultGuide
                        ? 'https://www.youtube.com/embed/hGNNwy4AnCs?autoplay=1&mute=1&loop=1&playlist=hGNNwy4AnCs'
                        : 'https://www.youtube.com/embed/oEuIsSc1rCo?autoplay=1&mute=1&loop=1&playlist=oEuIsSc1rCo'}
              title={isPriceGuide
                ? '스마트 가격 등록 안내 영상'
                : isProductGuide
                  ? '스마트 상품 등록 안내 영상'
                  : isEmailGuide
                    ? '상세 설정 이메일 발송 안내 영상'
                    : isScheduleGuide
                      ? '상세 설정 일정 스마트 등록 안내 영상'
                      : isConsultGuide
                        ? '상담(견적) 관리 스마트 활용 안내 영상'
                        : '상담-상품-예약 원플로우 안내 영상'}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
        </div>

        <div className="space-y-3 text-sm text-gray-700">
          {isPriceGuide ? (
            <>
              <p>
                스마트 가격 등록은 엑셀·표·텍스트로 정리된 출발일/요금을 붙여넣으면, 여러 날짜의 요금과 재고를 한 번에 생성해 주는 기능입니다.
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>여행사 견적서나 엑셀, 한글, 워드 문서에 있는 날짜·요금 표를 <b>그대로 붙여넣으면</b>, 날짜와 금액을 자동으로 인식합니다.</li>
                <li>적용 요일을 선택해 특정 요일만 요금을 적용하거나, 필요 없는 날짜는 미리 제외할 수 있습니다.</li>
                <li>공유 재고(시리즈)를 연결하면 여러 상품이 같은 좌석/재고를 함께 사용할 수 있어 관리가 쉬워집니다.</li>
              </ul>
            </>
          ) : isProductGuide ? (
            <>
              <p>
                스마트 상품 등록은 여행 일정, 도시, 기본 요금 등 필수 정보만 입력해서 <b>상품 등록</b>을 빠르게 도와 주는 기능입니다.
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>"스마트 가격 등록"과 연계하여 사용 할 수 있습니다.</li>
                <li>필수 정보만 입력한 뒤 엑셀, 워드, 한글 양식의 일정표를 복사해서 붙여넣으면 투어소개, 일정표, 가격/재고가 자동으로 생성됩니다.</li>
                <li>상품 생성 후 상세 설정 화면에서 일정별 이미지, 옵션 상품등을 추가로 차근차근 보완할 수 있습니다.</li>
              </ul>
            </>
          ) : isEmailGuide ? (
            <>
              <p>
                상세 설정화면 우측 일정표 미리보기 영역 상단 <b>이메일 보내기</b> 버튼을 통해 여행상품 웹 일정표를 바로 발송할 수 있습니다.
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>
                  이메일 발송 대상을 <b>등록한 거래처</b>로 지정하면, 해당 거래처에 저장된 <b>기본 이메일 주소</b>로 자동 발송됩니다.
                </li>
                <li>
                  이렇게 발송된 여행상품 웹 일정표의 <b>헤더와 푸터는 선택한 거래처에 등록된 헤더/푸터로 자동 변경</b>되어, 거래처 브랜드에 맞춘 일정표를 손쉽게 보낼 수 있습니다.
                </li>
                <li>
                  개인 이메일이나 다른 수신자에게 보낼 때도, 동일한 웹 일정표를 바로 공유할 수 있어 고객 응대가 빨라집니다.
                </li>
              </ul>
            </>
          ) : isScheduleGuide ? (
            <>
              <p>
                투어 상품 상세 설정 화면 상단의 <b>일정 스마트 등록</b> 버튼을 통해, 이미 등록된 상품도 엑셀·워드·한글로 정리된 일정표를 그대로 붙여넣어 상세 페이지 및 일정표를 간편하게 자동 생성할 수 있습니다.
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>상세 설정 화면에서 <b>일정 스마트 등록</b> 버튼을 클릭한 뒤, 기존에 사용하던 엑셀/워드/한글 일정표를 그대로 복사해서 붙여넣습니다.</li>
                <li>붙여넣은 일정표의 일자, 도시, 식사, 숙박 정보 등을 자동으로 인식해 여행상품 상세 페이지와 일정표를 한 번에 생성·갱신합니다.</li>
                <li>이미 등록된 상품을 리뉴얼하거나, 기존 랜드박스 일정표 양식의 일정표를 정식 일정표로 전환할 때도 유용합니다.</li>
              </ul>
            </>
          ) : isConsultGuide ? (
            <>
              <p>
                상담(견적) 관리 기능을 사용하면 상담을 등록할 때 자동으로 관련 상품이 생성되고, 상담에서 <b>견적(1인 가격)</b>을 생성하면 해당 금액이 자동으로 상품에 반영됩니다.
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>상담 등록 시 생성된 상품은 이후 상세 설정 화면에서 바로 확인할 수 있으며, 별도로 상품을 다시 만들 필요가 없습니다.</li>
                <li>상담 화면에서 생성한 1인 견적 가격은 자동으로 연결된 상품의 기본 요금/판매가에 반영되어 가격 중복 입력을 줄여 줍니다.</li>
                <li>자동 생성된 상품의 상세 설정 화면에서 <b>일정 스마트 등록</b>으로 일정표만 붙여넣고, 이어서 <b>이메일 보내기</b> 기능으로 웹 일정표를 발송하면 별도의 견적서를 작성하지 않고도 거래처나 고객에게 스마트하게 견적을 전달할 수 있습니다.</li>
              </ul>
            </>
          ) : (
            <>
              <p>
                상담(견적)에서 생성한 정보로 <b>상품 생성부터 예약 작성까지 한 흐름으로 이어지는 것</b>이 TRP 상담 관리의 가장 큰 장점입니다.
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>상담(견적)을 생성하면 해당 상담을 기준으로 한 상품이 <b>자동으로 생성</b>되어, 별도로 상품을 만들지 않고도 바로 예약 작성에 사용할 수 있습니다.</li>
                <li>일반적인 방식처럼 상품을 따로 만들고, 그 상품과 견적을 다시 매칭할 필요가 없기 때문에 상품 관리·견적 관리·예약 관리를 각각 따로 유지하지 않아도 됩니다.</li>
                <li>TRP에서는 상담–상품–예약이 하나의 흐름으로 연결되어, 한 번 생성한 상담 정보를 중심으로 견적 확인, 상품 상세 설정, 예약 생성까지 모두 <b>한 화면 흐름 안에서</b> 관리할 수 있습니다.</li>
              </ul>
            </>
          )}
        </div>

        <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={hasPrevTip && onPrevTip ? onPrevTip : undefined}
              disabled={!hasPrevTip}
              className={`inline-flex items-center justify-center px-3 py-1.5 text-xs font-medium rounded-lg border ${
                hasPrevTip
                  ? 'border-gray-300 text-gray-700 bg-white hover:bg-gray-50'
                  : 'border-gray-200 text-gray-400 bg-gray-50 cursor-not-allowed'
              }`}
            >
              이전 팁
            </button>
            <button
              type="button"
              onClick={hasNextTip && onNextTip ? onNextTip : undefined}
              disabled={!hasNextTip}
              className={`inline-flex items-center justify-center px-3 py-1.5 text-xs font-medium rounded-lg border ${
                hasNextTip
                  ? 'border-gray-300 text-gray-700 bg-white hover:bg-gray-50'
                  : 'border-gray-200 text-gray-400 bg-gray-50 cursor-not-allowed'
              }`}
            >
              다음 팁
            </button>
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-2 justify-end w-full sm:w-auto">
            {showDontShowOption && (
              <label className="inline-flex items-center gap-1 text-xs text-gray-600">
                <input
                  type="checkbox"
                  className="h-3.5 w-3.5 rounded border-gray-300 text-gray-900 focus:ring-gray-300"
                  checked={!!dontShow}
                  onChange={(e) => onChangeDontShow && onChangeDontShow(e.target.checked)}
                />
                <span>앞으로 보지 않기</span>
              </label>
            )}
            <button
              type="button"
              onClick={onClose}
              className="inline-flex items-center justify-center px-4 py-2 text-sm font-medium rounded-lg border border-gray-200 text-gray-700 bg-white hover:bg-gray-50"
            >
              닫기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartGuideModal;
